import { IGlobalState } from '../../../Root/store/appReducer'

export const getUserPreferencesList = (state: IGlobalState) => state.userPreferences.list
export const getUserPreferencesLoading = (state: IGlobalState) => state.userPreferences.isLoading
export const getUserPreferencesLastUpdate = (state: IGlobalState) => state.userPreferences.lastUpdate
